import { get } from "../../../Services/http";

export const getServicePoints = (city: string, streetName: string) => {
    return get(`/api/postnord?city=${city}&streetName=${streetName}`);
}